import { useOverlayHistoryState } from '@/core/features/modals/overlay-history/overlay-history-state';

export const useGalleryOverlayHistory = () => {
    return useOverlayHistoryState('gallery-overlay');
};

export const useGallerySwiperOverlayHistory = () => {
    return useOverlayHistoryState('gallery-swiper-overlay');
};
